module.exports = __webpack_public_path__ + "static/media/chu-mobile.5813f0e9.jpg";